import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title="handleSuccess" subtitle='() => void' mdxType="Item">
    Display a success screen.
    </Item>
    <Item title="handleFailure" subtitle='(errorMessage: string) => void' mdxType="Item">
      <p>{`Display `}<inlineCode parentName="p">{`errorMessage`}</inlineCode>{` as an error or failure message.`}</p>
    </Item>
    <Item title="continueWithNewClientToken" subtitle='(clientToken: string) => void' mdxType="Item">
      <p>{`Continue the payment flow using the given `}<inlineCode parentName="p">{`clientToken`}</inlineCode>{`.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      